export default {
    getCookieDate(period) {
        let now = new Date();
        now.setTime(now.getTime() + period * 24 * 60 * 60 * 1000);
        return now.toGMTString();
    },
    toLocalTZ(utc, fmt) {
		if ((utc == '')||(utc == undefined)) {
			return '';
		}
		let date = new Date(utc+" UTC");
		return date.toChar(fmt);
	},
	toUtcTZ(lctDt, fmt) {
		if ((lctDt == '')||(lctDt == undefined)) {
			return '';
		}
		let tl = lctDt.getTime();
		tl += (lctDt.getTimezoneOffset() * 60 * 1000);
		
		let date = new Date(lctDt.toChar('yyyy-MM-ddTHH:mm:ss'));
		date.setTime(tl)
		
		return date.toChar(fmt);
	},
	factString(str) {
		if (str == undefined) {
			return "";
		}

		let data = str.trim();

		return data;
	},
	checkZenKatakana(str) {
		str = (str == null) ? "" : str;
		if (str.match(/^[ァ-ヶー]+$/)) {
			return true;
		} else {
			return false;
		}
	},
	checkEmailAddressFormat(email) {
		email = (email == null) ? "" : email;
		if (email.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) {
			return true;
		} else {
			return false;
		}
	},
	formatTime(value) {
		let result = "";
		if ((value == "") || (value == undefined)) {
			result = ":";
		} else if (value.length < 2) {
			result = "0:0" + value;
		} else if (value.length < 3) {
			result = "0:";
			if (value.substr(0,2) < 60) {
				result = result + value.substr(0,2);
			} else {
				result = result + "00";
			}
		} else if (value.length < 4) {
			result = value.substr(0,1) + ":";
			if (value.substr(1,2) < 60) {
				result = result + value.substr(1,2);
			} else {
				result = result + "00";
			}
		} else if (value.length < 5) {
			result = value.substr(0,2);
			/*
			if (result > 23) {
				result = "23";
			}
			*/
			result = result + ":";
			if (result.substr(0,1) == "0") {
				result = result.substr(1,3);
			}
			if (value.substr(2,2) < 60) {
				result = result + value.substr(2,2);
			} else {
				result = result + "00";
			}
		}
		return result;
	},
	calcTimeRecords(data) {
		if ((data.start == ":") || (data.start == "") || (data.start == undefined)) {
			// 開始時刻が未入力ならコメント以外は初期化して抜ける
			data.end = "";
			data.time1 = "";
			data.time2 = "";
			data.time3 = "";
			data.time4 = "";
			data.breakTime = "";
			return;
		}
		if ((data.end == ":") || (data.end == "") || (data.end == undefined)) {
			// 終了時刻が未入力の場合は以降コメント以外を初期化して抜ける
			data.time1 = "";	
			data.time2 = "";
			data.time3 = "";
			data.time4 = "";
			data.breakTime = "";
			return;
		}
		
		let stm = this.convertToMinutes(data.start);
		let etm = this.convertToMinutes(data.end);
		let roudou = etm - stm; //<-- 労働時間（分）
		let breaktm = 0;	//<-- 休憩時間（退避用）

		data.time2 = 0;
		data.time3 = 0;
		data.time4 = 0;

		let sinya = 0;
		
		// 休憩時間
		if ((data.breakTime != "") && (data.breakTime != undefined)) {
			breaktm = data.breakTime;
		}
		if (roudou <= 360) {
			// 労働時間が6時間以下
			// 休憩時間が何もしない
		} else {
			// 労働時間が6時間以上
			// 休憩時間が空白の時のみ初期値をいれる
			if ((data.breakTime == "") || (data.breakTime == undefined)) {
				let rm = Math.floor(roudou / 480);
				if ((roudou % 480) <= 360) {
					
				}
				breaktm = 0.75;
				if (roudou > 480) {
					breaktm = 1;
					if (roudou > 900) {
						breaktm = 2;
						if (roudou > 1440) {
							breaktm = 3;
						}
					}
				}
				
				data.breakTime = breaktm;
			}
		}

		// 深夜労働時間
		let sin1m = this.convertToMinutes("22:00");
		let sin2m = this.convertToMinutes("29:00");
		let sin3m = this.convertToMinutes("5:00");

		if (etm > sin1m) {
			// 深夜労働を含む
			sinya = etm - sin1m
			if (etm > sin2m) {
				sinya = sinya - (etm - sin2m);
			}
		} else if (stm < sin3m) {
			sinya = sin3m - stm;
		}
		
		let btm = breaktm * 60;
		//let furikyu = this.chkFurikyu(data.comment)
		let furikyu = data.furikae;

		data.time3 = sinya / 60;
		roudou = roudou - (breaktm * 60);
		let zangyo = 0;
		let syotei = 480;
		if ((roudou - sinya) < 480) {
			syotei = (roudou - sinya);
		} else {
			zangyo = (roudou - syotei - sinya);
		}
		if (zangyo > 0) {
			data.time1 = syotei / 60;
			data.time2 = zangyo / 60;
		} else {
			data.time1 = (roudou - sinya) / 60;
		}
		
		if (((data.holiday == 1) || (data.day == 0) || (data.day == 6)) && (!furikyu)) {
			data.time4 = (roudou - sinya) / 60;
			data.time1 = "";
			data.time2 = "";
		}

		return;
	},
	convertCurrency(value, unit) {
		if (value === "" || value === undefined || value === null) {
			return "";
		}
		if (Number.isNaN(parseInt(value))) {
			return value;
		}
		let result = (value - 0).toLocaleString();
		if ((unit != "") && (unit != undefined)) {
			result = unit + result;
		}
		return result;
	},
	convertToMinutes(tim) {
		let times = tim.split(':');
		let res = Number(times[0]) * 60 + Number(times[1]);
		return res;
	},
	convertToTimeString(tim) {
		let h = tim / 60 | 0;
		let m = tim % 60;
		
		return h + (m / 60);
	},
	checkCommentRecords(data) {
		let comment = "";
		let coms = data.comment.split(" ");
		
		let cvnFlg = false;
		for (let i = 0; i < coms.length; i++) {
			let com = coms[i];
			if (com.substr(0,1) == "#") {
				let numb = com.substr(1, com.length - 1);
				if (numb == 4) {
					if (!cvnFlg) {
						cvnFlg = true;
						comment = (comment == "" ? com : comment + " " + com);
					}
				} else {
					comment = (comment == "" ? com : comment + " " + com);
				}
			} else {
				comment = (comment == "" ? com : comment + " " + com);
			}
		}

		// 休暇コメント
		let leaves = data.leaveList
		for (let i = 0; i< leaves.length; i++) {
			let leave = leaves[i];
			let leaveComment = this.getLeaveComment(leave.leaveType, leave.timeType, leave.halfType, leave.leaveTimes,  leave.leaveName);
			if (comment.indexOf(leaveComment) == -1) {
				comment = comment + " " + leaveComment // 休暇コメントは削除不可
			}
		}

		// 振替休日
		if (data.furikae) {
			let furikaeComment = this.getFurikaeComment(data);
			if (comment.indexOf(furikaeComment) == -1) {
				comment = comment + " " + furikaeComment // 振休コメントは削除不可
			}
		}
		
		data.comment = comment;

	},
	chkFurikyu(comment) {
		let result = false;

		if ((comment == "") || (comment == undefined)) {
			return result;
		}

		let coms = comment.split(" ");
		for (let i = 0; i < coms.length; i++) {
			let com = coms[i];
			if (com.substr(0,1) == "#") {
				let numb = com.substr(1, com.length - 1);
				if (numb == "4") {
					result = true;
					break;
				}
			}
		}

		return result;
	},
	getLeaveComment(leaveType, timeType, halfType, leaveTimes, leaveName) {
		let comment = "";

		if (leaveType == "1") {
			comment = "有休";
		} else {
			comment = leaveName;
		}

		if (timeType == "2") {
			if (halfType == "1") {
				comment = comment + "AM";
			} else {
				comment = comment + "PM";
			}
		} else if (timeType == 3) {
			comment = comment + "(" + leaveTimes + "H)";
		}
	
		return comment;
	},
	getFurikaeComment(data) {
		let comment = "";
		if (data.furikaeDate == "" || data.furikaeDate == undefined) {
			return comment;
		}

		let date = new Date(data.furikaeDate);
		let str = "へ";
		if (data.day != 6 && data.day != 0 && !data.holiday) {
			str = "分"
		}

		comment = "振休 (" + date.toChar("M月d日") + str + ")";
		
		return comment;
	},
	convertComment(value) {
		let result = "";
		let re = new RegExp("");
		re.compile("^([1-9]d*|0)$");

		if ((value == "") || (value == undefined)) {
			return result;
		}

		let coms = value.split(" ");

		for (let i = 0; i < coms.length; i++) {
			let com = coms[i];
			if (com.substr(0,1) == "#") {
				let numb = com.substr(1, com.length - 1);
				if (re.test(numb)) {
					numb = numb - 0;
					switch(numb) {
						case 1:
							com = "有休";
							if ((result.indexOf("半休") !== -1) || (result.indexOf("特休") !== -1) || (result.indexOf("振休") !== -1)) {
								com = "";
							}
							break;
						case 2:
							com = "半休";
							if ((result.indexOf("有休") !== -1) || (result.indexOf("特休") !== -1) || (result.indexOf("振休") !== -1)) {
								com = "";
							}
							break;
						case 3:
							com = "特休";
							if ((result.indexOf("有休") !== -1) || (result.indexOf("半休") !== -1) || (result.indexOf("振休") !== -1)) {
								com = "";
							}
							break;
						case 4:
							com = "振休";
							if ((result.indexOf("有休") !== -1) || (result.indexOf("半休") !== -1) || (result.indexOf("特休") !== -1)) {
								com = "";
							}
							break;
					}
				}
			}
			if (com != "") {
				result = (i == 0 ? com : result + " " + com);
			}
		}
		
		return result;
	}
}